module.exports = __webpack_public_path__ + "img/catch_copy_3.8c9a22db.png";